// @flow
import React from 'react';
import useSheet from 'app/jss';
import * as cssUtils from 'app/utils/cssUtils';
import classNames from 'classnames';
import Tappable from 'app/components/commons/Tappable';
import { noop, get } from 'lodash';
import colorUtils from 'color';
import Icon from 'app/components/commons/Icon';

type Props = {
  children?: any,
  group: FriendGroup,
  onClick: (groupId: FriendGroup) => void,
  selected?: boolean,
  sheet: Object,
};

const defaultProps = {
  selected: false,
};

class FriendGroupItem extends React.Component {
  props: Props;

  static defaultProps = {
    onClick: noop,
    children: undefined,
  }

  handleClick = () => {
    const { group, onClick } = this.props;
    onClick(group);
  }

  render() {
    const {
      children,
      selected,
      sheet: { classes },
    } = this.props;
    return (
      <Tappable
        component="div"
        className={classNames(classes.groupItem, {
          selected,
        })}
        onTap={this.handleClick}
      >
        <Icon type="icon-group" className={classes.icon} />
        <div className={classes.itemContent}>{children}</div>
        <span className={classNames(classes.itemCheck, { selected })}>
          <Icon type="icon-tick" />
        </span>
      </Tappable>
    );
  }
}

FriendGroupItem.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    groupItem: {
      display: 'flex',
      flexShrink: 0,
      alignItems: 'center',
      padding: [0, 10],
      height: 50,
      fontSize: 16,
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      backgroundColor: theme.color.basis6,
      color: theme.color.basis2,
      transition: 'background-color 0.1s linear',
      borderBottom: {
        color: theme.color.basis6,
        width: 1,
        style: 'solid',
      },
      '& >*:not(:last-child)': {
        marginRight: 10,
      },
      '&.selected': {
        backgroundColor: theme.color.white,
        ...cssUtils.hover({
          backgroundColor: colorUtils(theme.color.white).darken(0.05).hex(),
        }),
        '& $icon': {
          color: theme.color.primary,
        },
      },
      ...cssUtils.hover({
        backgroundColor: colorUtils(theme.color.basis6).darken(0.05).hex(),
      }),
      [theme.mediaQuery.desktopAndUp]: {
        fontSize: 15,
      },
    },
    itemCheck: {
      height: 16,
      width: 16,
      fontSize: 12,
      border: {
        width: 1,
        style: 'solid',
        color: theme.color.basis6,
      },
      color: theme.color.primary,
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& >*': {
        opacity: 0,
        transition: 'opacity 0.1s linear',
      },
      '&.selected > *': {
        opacity: 1,
      },

    },
    icon: {
      transition: 'color 0.1s linear',
      color: theme.color.basis4,

    },
    itemContent: {
      flexGrow: 1,
      // dealing with the fonts dumb extra sizing
      marginTop: 2,
    },
  };
}

export default useSheet(applyStyles)(FriendGroupItem);
